import { Model } from '@vuex-orm/core'
import HotelSearch from '@/models/hotels/HotelSearch'
import Customer from '@/models/user/Customer'
import AppState from '@/utils/app.state'
import Profile from './Profile'
import { ValidateVoucherRes, validateVoucher } from '@/data/service/voucher'

export default class Voucher extends Model {
  // API fields
  declare voucherCode: string
  declare surname: string
  declare isValid: boolean
  declare expiryDate: string
  declare remainingBalance: number
  // UI fields
  declare quantity: number
  declare isActive: boolean

  static entity = 'vouchers'
  static primaryKey = 'voucherCode'

  static fields() {
    return {
      voucherCode: this.string(''),
      quantity: this.number(0),
      expiryDate: this.string(''),
      surname: this.string(''),
      isValid: this.boolean(false),
      isActive: this.boolean(false),
      remainingBalance: this.number(0),
    }
  }

  static getActiveVouchers() {
    return Voucher.query().where('isActive', true).get()
  }

  static async validate(voucherCode: string, saveIfValid = true): Promise<ValidateVoucherRes> {
    const hotelSearch = HotelSearch.query().first()
    const bookerSurname = Customer.query().first()?.surName || Profile.query().first()?.lastname
    const propertyId = hotelSearch?.propertyId
    if (!bookerSurname || !propertyId) {
      return {
        isValid: false
      }
    }

    const data = await validateVoucher({
      bookerSurname,
      voucherCode,
      checkIn: hotelSearch.startDate,
      checkOut: hotelSearch.endDate,
      propertyId,
      currency: AppState.currency
    })

    if (saveIfValid && data.isValid) {
      await Voucher.insertOrUpdate({ data })
    }

    return data
  }
}
